import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';

export const SlackIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={dimensions} height={dimensions}>
			<svg width={dimensions} height={dimensions} viewBox="0 0 126 126" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80zm6.6 0c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z"
					fill="#E01E5A"
				/>
				<path
					d="M47 27c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.5 39.7.6 47 .6c7.3 0 13.2 5.9 13.2 13.2V27H47zm0 6.7c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H13.9C6.6 60.1.7 54.2.7 46.9c0-7.3 5.9-13.2 13.2-13.2H47z"
					fill="#36C5F0"
				/>
				<path
					d="M99.9 46.9c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.9V46.9zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V13.8C66.9 6.5 72.8.6 80.1.6c7.3 0 13.2 5.9 13.2 13.2v33.1z"
					fill="#2EB67D"
				/>
				<path
					d="M80.1 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8h13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80.1z"
					fill="#ECB22E"
				/>
			</svg>
		</StyledSpan>
	);
};

SlackIcon.SIZE = SIZE;
SlackIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};

const StyledSpan = Styled.div`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
